import { z } from "zod";

/**
 * `import.meta.env` ga murojaat qiladigan YAGONA fayl (eslint qoidasi buni
 * majburlaydi). Backend `src/config/env.schema.ts` va web `src/lib/env.ts`
 * bilan bir xil g'oya: noto'g'ri konfiguratsiya bilan ilova umuman
 * ko'tarilmasin.
 */
const schema = z.object({
  VITE_API_BASE_URL: z.url(),
  VITE_WEB_URL: z.url(),
  VITE_SENTRY_DSN: z.string().optional().default(""),
});

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  throw new Error(
    `Muhit o'zgaruvchilari noto'g'ri:\n${z.prettifyError(parsed.error)}\n` +
      "`.env.example` ga qarang.",
  );
}

export const env = parsed.data;

export const isProduction = import.meta.env.PROD;
